import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ClientListPage } from './pages/ClientListPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { ClientCreatePage } from './pages/ClientCreatePage';
import { DriftDashboardPage } from './pages/DriftDashboardPage';
import { AccountPage } from './pages/AccountPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { GroupsPage } from './pages/GroupsPage';
import { PermissionsPage } from './pages/PermissionsPage';
import { ChangelogPage } from './pages/ChangelogPage';
import { LandingPage } from './pages/LandingPage';
import { DeniedPage } from './pages/DeniedPage';
import { useSession } from './lib/useSession';

export function App() {
  const session = useSession();

  // Auth gate: nothing about the admin surface (sidebar, routes, data)
  // renders until /api/me confirms a permitted session.
  if (session.state === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="font-mono text-[11px] tracking-eyebrow uppercase text-ink-3">
          ◆ Verifying session…
        </div>
      </div>
    );
  }

  if (session.state === 'unauthenticated') {
    return (
      <Routes>
        <Route path="/denied" element={<DeniedPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    );
  }

  if (session.state === 'forbidden') {
    return <DeniedPage hasSession />;
  }

  if (session.state === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg px-6">
        <div className="text-center">
          <div className="font-mono text-[10px] tracking-eyebrow uppercase text-err-soft mb-2">
            ◆ Service Error
          </div>
          <p className="text-sm text-ink-2 mb-4">
            Could not reach the admin API: {session.errorMessage}
          </p>
          <a href="/" className="eo-btn eo-btn--ghost inline-block">Retry</a>
        </div>
      </div>
    );
  }

  return (
    <AppShell user={session.user!}>
      <Routes>
        <Route path="/" element={<ClientListPage />} />
        <Route path="/clients/new" element={<ClientCreatePage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/drift" element={<DriftDashboardPage />} />
        <Route path="/audit" element={<AuditLogPage />} />
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/permissions" element={<PermissionsPage />} />
        <Route path="/account" element={<AccountPage />} />
        {/* An authenticated, permitted user has no business on /denied. */}
        <Route path="/denied" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
